import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import useLogin from "../../../../custom-hooks/useLogin";
import "./SubscriptionInfoBannerComponent.scss";
import {
  fetchSubscribedData,
  fetchSubscribedDataClear,
  setPreSubscriptionReceiptData,
  subscriptionCheckoutPage,
} from "../../../../redux/checkout/actions";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import { SessionKeys, clickStreamUser } from "../../../../utils/AppUtils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { routeList } from "../../../../utils/routeList";
import { setPaymentMethodDetail } from "../../../../redux/payment/actions";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";

const SubscriptionInfoBannerComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoggedIn, userData } = useLogin();
  const subscribedInfo = useSelector((state) => state.checkout.subscribedData);

  const [greetLine, setGreetLine] = useState("");
  const [isShimmer, setIsShimmer] = useState(false);
  const [subscribedData, setSubscribedData] = useState({});

  useEffect(() => {
    if (isLoggedIn) {
      setIsShimmer(true);
      dispatch(
        fetchSubscribedData({
          method: "POST",
          URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_SUBSCRIBED_DATA}`,
          payload: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          },
          isJSON: true,
        })
      );
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
          if (!_.isEmpty(subscribedInfo)) {
            setIsShimmer(false);
              if (subscribedInfo.status === 'success') {
                  const data = subscribedInfo.payload.data;
                  if (!_.isEmpty(data)) setSubscribedData(data)
                  else setSubscribedData({})
              } else {
                  setSubscribedData({})
              }
              dispatch(fetchSubscribedDataClear());
          }
      }, [subscribedInfo])

  useEffect(() => {
    if (!_.isEmpty(subscribedData)) {
      if (_.toNumber(subscribedData.subscription_active)) {
        if (subscribedData.renewal_count > 1) {
          setGreetLine(
            `Hi ${subscribedData.first_name}, You are subscribed to Xsel ${subscribedData.subscription_name}.`
          );
        } else if (_.toNumber(subscribedData.is_self_purchased) == 0) {
          setGreetLine(
            `Hi ${subscribedData.first_name}, You are subscribed to Xsel ${subscribedData.subscription_name} by your brokerage.`
          );
        } else {
          setGreetLine(
            `Hi ${subscribedData.first_name}, You are subscribed to Xsel ${subscribedData.subscription_name}.`
          );
        }
      } else if (subscribedData.cancellation_date) {
        setGreetLine(
          `Hi ${subscribedData.first_name}, your Xsel ${subscribedData.subscription_name} subscription is cancelled by you.`
        );
      } else {
        setGreetLine(
          `Hi ${subscribedData.first_name}, your Xsel ${subscribedData.subscription_name} subscription is unsuccessfull.`
        );
      }
    }
  }, [subscribedData]);

  const goToPage = (pageName) => {
    // eslint-disable-next-line default-case
    switch (pageName) {
      case "payment-update":
        dispatch(
          setPaymentMethodDetail({
            stripeSubscriptionId: subscribedData.stripe_subscription_id,
          })
        );
        clickStreamUser("btn-clicked-update-payment", {
          user_id: userData.user_id,
        });
        navigate(routeList.PAYMENT_UPDATE_PAGE);
        return;
    }
  };

  return (
    <>
    {isShimmer?<div className="recipt-section container recipt-text-box">
                      <div className="mt-2"><ShimmerScreen case="rect" width="10rem" height="1.5rem" /></div>
                      <div className="mt-2"><ShimmerScreen case="rect" width="50rem" height="1.5rem" /></div>
                      <div className="mt-2"><ShimmerScreen case="rect" width="30rem" height="1.5rem" /></div>
                      </div>:
      isLoggedIn && !_.isEmpty(subscribedData) ? (
        <section
          className={`recipt-section ${
            subscribedData.subscription_active ? "" : "receipt-failed"
          }`}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="recipt-box">
                  <div className="recipt-icon">
                    <svg
                      width="72"
                      height="72"
                      viewBox="0 0 72 72"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 66C15.5 66 13.375 65.125 11.625 63.375C9.875 61.625 9 59.5 9 57V48H18V6L22.5 10.5L27 6L31.5 10.5L36 6L40.5 10.5L45 6L49.5 10.5L54 6L58.5 10.5L63 6V57C63 59.5 62.125 61.625 60.375 63.375C58.625 65.125 56.5 66 54 66H18ZM54 60C54.85 60 55.5625 59.7125 56.1375 59.1375C56.7125 58.5625 57 57.85 57 57V15H24V48H51V57C51 57.85 51.2875 58.5625 51.8625 59.1375C52.4375 59.7125 53.15 60 54 60ZM27 27V21H45V27H27ZM27 36V30H45V36H27ZM51 27C50.15 27 49.4375 26.7125 48.8625 26.1375C48.2875 25.5625 48 24.85 48 24C48 23.15 48.2875 22.4375 48.8625 21.8625C49.4375 21.2875 50.15 21 51 21C51.85 21 52.5625 21.2875 53.1375 21.8625C53.7125 22.4375 54 23.15 54 24C54 24.85 53.7125 25.5625 53.1375 26.1375C52.5625 26.7125 51.85 27 51 27ZM51 36C50.15 36 49.4375 35.7125 48.8625 35.1375C48.2875 34.5625 48 33.85 48 33C48 32.15 48.2875 31.4375 48.8625 30.8625C49.4375 30.2875 50.15 30 51 30C51.85 30 52.5625 30.2875 53.1375 30.8625C53.7125 31.4375 54 32.15 54 33C54 33.85 53.7125 34.5625 53.1375 35.1375C52.5625 35.7125 51.85 36 51 36ZM18 60H45V54H15V57C15 57.85 15.2875 58.5625 15.8625 59.1375C16.4375 59.7125 17.15 60 18 60Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="recipt-text-box">
                    <div className="recipt-user-name">{greetLine}</div>
                    {
                      _.toNumber(subscribedData.is_self_purchased) == 1 && (
                      <>
                        <div className="recipt-text">
                          { !_.isEmpty(subscribedData?.upcoming_subscription)?<></>:_.toNumber(subscribedData.subscription_active) ? (
                            <>
                              Your subscription will renew automatically on{" "}
                              {moment
                                .unix(subscribedData.next_renewal_date)
                                .format("MMM DD, YYYY")}, under your current monthly billing plan, and renewal
                                reminders will be sent to {subscribedData.email}.
                            </>
                          ) : subscribedData.cancellation_date ? (
                            <>
                              Your subscription was cancelled on{" "}
                              {moment
                                .unix(subscribedData.cancellation_date)
                                .format("MMM DD, YYYY")}
                              . You were on the {subscribedData.billing_type}{" "}
                              billing plan. Please check and update your payment
                              details or you can renew now.
                            </>
                          ) : (
                            <>
                              Your subscription ended on{" "}
                              {moment
                                .unix(subscribedData.next_renewal_date)
                                .format("MMM DD, YYYY")}
                              . You are on the {subscribedData.billing_type}{" "}
                              billing plan. Please check and update your payment
                              details
                            </>
                          )}

                          {
                          !_.isEmpty(subscribedData?.upcoming_subscription) ?
                          <>
                          {
                          subscribedData?.upcoming_subscription?.title === "Starter"?
                          <>
                          Your Xsel {subscribedData?.subscription_name} subscription will end on {moment
                                .unix(
                                  subscribedData?.upcoming_subscription
                                    ?.previous_subscription_end_date
                                )
                                .format("MMM DD, YYYY")}.{" "}<br />
                          On the next day, your account will automatically switch to our free Starter plan.<br /><br />
                          We’re glad you’re staying with us! While the Starter plan includes limited access, you’ll still be able to explore select tools and resources on Xsel.<br />
                          If you ever want to unlock full features again, upgrading is quick and easy.<br />
                          Your current {subscribedData?.subscription_name} subscription is active until {moment
                                .unix(
                                  subscribedData?.upcoming_subscription
                                    ?.previous_subscription_end_date
                                )
                                .format("MMM DD, YYYY")}, and we’ll send the final reminders to {subscribedData.email}.<br />
                          Thanks for being part of the Xsel community—we’re here whenever you’re ready to grow further.
                          </>
                          :
                           <>
                          We’ve successfully processed your subscription change.
                          Your Xsel {subscribedData?.subscription_name} plan will remain active until {moment
                                .unix(
                                  subscribedData?.upcoming_subscription
                                    ?.previous_subscription_end_date
                                )
                                .format("MMM DD, YYYY")}, after which your new {subscribedData?.upcoming_subscription?.title} subscription will begin.<br />
                          We’re glad you’re continuing your learning journey with us—and while the {subscribedData?.upcoming_subscription?.title} plan still offers great tools and resources,
                          we’ll miss providing you with the full Premium experience.<br />
                          If you change your mind, you can upgrade again anytime with just a few clicks.<br />
                          Your {subscribedData?.upcoming_subscription?.title} subscription will continue on a monthly basis and renew automatically,
                          we will continue to send reminder e-mail to this address {subscribedData.email}<br />
                          Thanks for being a part of the Xsel community. We’re here to support you every step of the way.
                          </>}
                          </>
                          :
                         ""
                          }


                          {!_.isEmpty(subscribedData?.upcoming_subscription) && false ? (
                          isShimmer?<div className="mt-2"><ShimmerScreen case="rect" width="50rem" height="1.5rem" /></div>
                          :<div className="mt-2">
                              (Your Current {subscribedData?.subscription_name}{" "}
                              subscription will end on{" "}
                              {moment
                                .unix(
                                  subscribedData?.upcoming_subscription
                                    ?.previous_subscription_end_date
                                )
                                .format("MMM DD, YYYY")}{" "}
                              and Your new{" "}
                              {subscribedData.upcoming_subscription?.title}{" "}
                              subscription will starts from the same day
                              {/* {moment
                                .unix(
                                  subscribedData?.upcoming_subscription
                                    ?.new_subscription_start_date
                                )
                                .format("MMM DD, YYYY")} */}
                              )
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="recipt-btns">
                          {!_.toNumber(subscribedData.subscription_active) && (
                            <button
                              className="recopt-btn"
                              onClick={() => {
                                dispatch(
                                  subscriptionCheckoutPage({
                                    subscriptionId: subscribedData.ecom_sub_id,
                                    billingType: subscribedData.billing_type,
                                  })
                                );

                                navigate(routeList.PAYMENT_PAGE_SUBSCRIPTION);
                              }}
                            >
                              <svg
                                width="20"
                                height="18"
                                viewBox="0 0 20 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M18.3333 7.33333H1.66666M9.16666 14.8333L15.6667 14.8333C16.6001 14.8333 17.0668 14.8333 17.4233 14.6517C17.7369 14.4919 17.9919 14.2369 18.1517 13.9233C18.3333 13.5668 18.3333 13.1001 18.3333 12.1667V5.83333C18.3333 4.89991 18.3333 4.4332 18.1517 4.07668C17.9919 3.76308 17.7369 3.50811 17.4233 3.34832C17.0668 3.16667 16.6001 3.16667 15.6667 3.16667H14.1667M9.16666 14.8333L10.8333 16.5M9.16666 14.8333L10.8333 13.1667M5.83332 14.8333H4.33332C3.3999 14.8333 2.93319 14.8333 2.57667 14.6517C2.26307 14.4919 2.0081 14.2369 1.84831 13.9233C1.66666 13.5668 1.66666 13.1001 1.66666 12.1667V5.83333C1.66666 4.89991 1.66666 4.4332 1.84831 4.07668C2.0081 3.76308 2.26307 3.50811 2.57667 3.34832C2.93319 3.16667 3.3999 3.16667 4.33332 3.16667H10.8333M10.8333 3.16667L9.16666 4.83333M10.8333 3.16667L9.16666 1.5"
                                  stroke="#6941C6"
                                  strokeWidth="1.66667"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Renew now
                            </button>
                          )}
                          <button
                            className="recopt-btn"
                            onClick={() => {
                              dispatch(
                                setPreSubscriptionReceiptData({
                                  subscriptionId:
                                    subscribedData.stripe_subscription_id,
                                })
                              );
                              navigate(routeList.VIEW_SUBSCRRIPTION_RECEIPT);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M16.6663 10.4167V5.66675C16.6663 4.26662 16.6663 3.56655 16.3939 3.03177C16.1542 2.56137 15.7717 2.17892 15.3013 1.93923C14.7665 1.66675 14.0665 1.66675 12.6663 1.66675H7.33301C5.93288 1.66675 5.23281 1.66675 4.69803 1.93923C4.22763 2.17892 3.84517 2.56137 3.60549 3.03177C3.33301 3.56655 3.33301 4.26662 3.33301 5.66675V14.3334C3.33301 15.7335 3.33301 16.4336 3.60549 16.9684C3.84517 17.4388 4.22763 17.8212 4.69803 18.0609C5.23281 18.3334 5.93288 18.3334 7.33301 18.3334H9.99967M11.6663 9.16675H6.66634M8.33301 12.5001H6.66634M13.333 5.83341H6.66634M12.083 15.8334L13.7497 17.5001L17.4997 13.7501"
                                stroke="#6941C6"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            View receipt
                          </button>
                          <button
                            className="recopt-btn"
                            onClick={() => goToPage("payment-update")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                opacity="0.12"
                                d="M1.66699 6.83341V8.33341H18.3337V6.83342C18.3337 5.9 18.3337 5.43328 18.152 5.07677C17.9922 4.76316 17.7372 4.50819 17.4236 4.34841C17.0671 4.16675 16.6004 4.16675 15.667 4.16675H4.33366C3.40024 4.16675 2.93353 4.16675 2.57701 4.3484C2.2634 4.50819 2.00844 4.76316 1.84865 5.07676C1.66699 5.43328 1.66699 5.89999 1.66699 6.83341Z"
                                fill="black"
                              />
                              <path
                                d="M1.66699 8.33341H18.3337V6.83342C18.3337 5.89999 18.3337 5.43328 18.152 5.07677C17.9922 4.76316 17.7372 4.50819 17.4236 4.34841C17.0671 4.16675 16.6004 4.16675 15.667 4.16675H4.33366C3.40024 4.16675 2.93353 4.16675 2.57701 4.3484C2.2634 4.50819 2.00844 4.76316 1.84865 5.07676C1.66699 5.43328 1.66699 5.89999 1.66699 6.83342V13.1667C1.66699 14.1002 1.66699 14.5669 1.84865 14.9234C2.00844 15.237 2.2634 15.492 2.57701 15.6518C2.93353 15.8334 3.40024 15.8334 4.33366 15.8334H9.16699M12.0837 17.5001L13.7711 17.1626C13.9183 17.1332 13.9918 17.1184 14.0604 17.0915C14.1213 17.0677 14.1792 17.0367 14.2329 16.9993C14.2933 16.9571 14.3463 16.9041 14.4525 16.798L17.917 13.3334C18.3772 12.8732 18.3772 12.127 17.917 11.6667C17.4568 11.2065 16.7106 11.2065 16.2503 11.6667L12.7858 15.1313C12.6797 15.2374 12.6266 15.2904 12.5845 15.3509C12.5471 15.4045 12.5161 15.4624 12.4922 15.5233C12.4653 15.5919 12.4506 15.6655 12.4212 15.8126L12.0837 17.5001Z"
                                stroke="#6941C6"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Update payment details
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default SubscriptionInfoBannerComponent;
